var _rect, _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgJuliaDark(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 256,
    height: 256,
    viewBox: "0 0 256 256",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 256,
    height: 256,
    rx: 60,
    fill: "#242938"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M118.509 177.431C118.509 203.866 97.3497 225.282 71.2544 225.282C45.1484 225.282 24 203.866 24 177.431C24 151.006 45.1484 129.58 71.2544 129.58C97.3497 129.58 118.509 151.006 118.509 177.431Z",
    fill: "#CB3C33"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M232.046 177.431C232.046 203.866 210.887 225.282 184.791 225.282C158.696 225.282 137.537 203.866 137.537 177.431C137.537 151.006 158.696 129.58 184.791 129.58C210.887 129.58 232.046 151.006 232.046 177.431Z",
    fill: "#9558B2"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M175.288 77.8511C175.288 104.276 154.129 125.702 128.033 125.702C101.927 125.702 80.7791 104.276 80.7791 77.8511C80.7791 51.4262 101.927 30 128.033 30C154.129 30 175.288 51.4262 175.288 77.8511Z",
    fill: "#389826"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgJuliaDark);
export default __webpack_public_path__ + "static/media/Julia-Dark.990217c10525c425ef22ee7237f1d157.svg";
export { ForwardRef as ReactComponent };